// extracted by mini-css-extract-plugin
module.exports = {"box":"box--5jKGM","header":"header--37A5Z","logo":"logo--TBb8N","nav":"nav--GF+Bq","active":"active--+m8-i","a":"a--YDyYy"};